import React from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { PromoDiskButton } from 'components/no-auth/common/PromoDiskButton/PromoDiskButton';
import LogoPurple from 'components/no-auth/header-fixed/LogoPurple';

import { toggleNavModal } from 'actions/appAction';

import clsx from 'clsx';

import HeaderFixedButtons from './HeaderFixedButtons';
import styles from './HeaderFixedDesktop.module.css';

const HeaderFixedDesktop = (props) => {
    const location = useLocation();

    const linkIsSelected = (link) =>
        link.nav_links.some((nl) => nl.url === location.pathname) ||
        link.submenu?.some((submenu) => submenu.nav_links.some((nl) => nl.url === location.pathname));
    const navLinkIsSelected = (navlink) => navlink.url === location.pathname;

    const hasExternalButton = props.authData[0]?.nav_links.some((link) => link.isExternalButton);

    const containerClass = clsx(styles.headerContainer, {
        [styles.containerFixed]: props.isFixed,
        [styles.containerNavModal]: props.isShowNavModal,
        [styles.containerWhite]: !props.promoDarkPage,
    });

    const buttonsClass = clsx(styles.buttonsWrapper, {
        [styles.buttonsWrapperFixed]: hasExternalButton && props.isFixed,
        [styles.buttonsWrapperBlog]: props.isBlogPage,
    });

    const renderMenuLinks = (link) => {
        return (
            <li key={link.id}>
                <a
                    className={`${styles.subMenuLink} ${props.promoDarkPage ? styles.subMenuLinkDark : null} ${navLinkIsSelected(link) ? styles.subMenuLinkSelected : ''}`}
                    tabIndex={'0'}
                    href={link.url}
                    title={link.title}
                    target={link.isBlank ? '_blank' : null}
                >
                    {link?.icon?.url && <img className={styles.topMenuIcon} src={link.icon?.url} alt={link.title} width={'24'} height={'24'} />}
                    {link.title}
                </a>
            </li>
        );
    };

    if (props.libre) {
        return (
            <div className={styles.libreHeader}>
                <div className={styles.headerContent}>
                    <div className={styles.flexPanel}>
                        <div className={styles.headerLogo}>
                            <LogoPurple lang={props.lang} country={props.country} />
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <header className={containerClass}>
                <div className={styles.headerContent}>
                    <div className={styles.flexPanel}>
                        <div className={styles.headerLogo}>
                            <LogoPurple whiteColor={props.promoDarkPage} lang={props.lang} country={props.country} />
                        </div>
                        <ul className={styles.topMenu}>
                            {props.data &&
                                props.data
                                    .filter((item) => item !== null)
                                    .map((link) => {
                                        return (
                                            link.authorised_user === false && (
                                                <li key={link.id}>
                                                    <a
                                                        className={`${styles.topMenuLink} ${props.promoDarkPage ? styles.topMenuLinkDark : null} ${linkIsSelected(link) ? styles.topMenuLinkSelected : ''}`}
                                                        tabIndex={'0'}
                                                    >
                                                        {link.title}
                                                    </a>
                                                    {link.submenu && link.submenu.length > 0 ? (
                                                        <nav className={`${styles.subMenu} ${props.promoDarkPage ? styles.subMenuDark : null}`}>
                                                            <ul>
                                                                {link.submenu.map((submenuItem, index) => (
                                                                    <li key={index}>
                                                                        {submenuItem.submenu_title && (
                                                                            <span className={styles.submenuTitle}>{submenuItem.submenu_title}</span>
                                                                        )}
                                                                        <ul>
                                                                            {submenuItem.nav_links
                                                                                .filter((item) => item !== null)
                                                                                .map((navlink) => renderMenuLinks(navlink))}
                                                                        </ul>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </nav>
                                                    ) : (
                                                        <nav className={`${styles.subMenu} ${props.promoDarkPage ? styles.subMenuDark : null}`}>
                                                            <ul>{link.nav_links.filter((item) => item !== null).map((navlink) => renderMenuLinks(navlink))}</ul>
                                                        </nav>
                                                    )}
                                                </li>
                                            )
                                        );
                                    })}
                        </ul>

                        <div>
                            {props.authData && (
                                <div className={buttonsClass}>
                                    <HeaderFixedButtons
                                        isLanding={props.isLanding}
                                        pageName={props.pageName}
                                        data={props.authData}
                                        fixedHeader={props.isFixed}
                                        hasChatButton={props.hasChatButton}
                                    />
                                </div>
                            )}

                            <div className={styles.navButtonWrapper}>
                                {!props.isShowNavModal ? (
                                    <PromoDiskButton
                                        type="button"
                                        iconName="burger"
                                        isNavButton
                                        isNavButtonInverted={props.promoDarkPage}
                                        labelText="Show navigation menu"
                                        onClick={() => props.toggleNavModal(true)}
                                        onKeyPress={() => props.toggleNavModal(true)}
                                        tabIndex="0"
                                    />
                                ) : (
                                    <PromoDiskButton
                                        type="button"
                                        iconName="cross"
                                        isNavButton
                                        isNavButtonInverted={props.promoDarkPage}
                                        labelText="Close navigation menu"
                                        onClick={() => props.toggleNavModal(false)}
                                        onKeyPress={() => props.toggleNavModal(false)}
                                        tabIndex="0"
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
};

const mapStateToProps = (state) => ({
    lang: state.extra.noAuthFooter?.language?.lang,
    country: state.extra.noAuthFooter?.language?.country,
    isShowNavModal: state.app.isShowNavModal,
});

export default connect(mapStateToProps, { toggleNavModal })(HeaderFixedDesktop);
